interface AppStatusBadgeProps {
  online: boolean;
  label?: string;
  className?: string;
}

export function AppStatusBadge({ online, label, className = '' }: AppStatusBadgeProps) {
  return (
    <div
      className={`
        flex shrink-0 items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-semibold
        ${online
          ? 'bg-emerald-500/10 text-emerald-400 ring-1 ring-emerald-500/20'
          : 'bg-red-500/10 text-red-400 ring-1 ring-red-500/20'
        }
        ${className}
      `.trim()}
      role="status"
    >
      <span
        className={`h-1.5 w-1.5 rounded-full ${online ? 'animate-pulse bg-emerald-400' : 'bg-red-400'}`}
        aria-hidden="true"
      />
      {label ?? (online ? 'Online' : 'Offline')}
    </div>
  );
}
